module.exports = __webpack_public_path__ + "img/borderRightArrow2White.444900dc.svg";